import { render, staticRenderFns } from "./Profile2El.vue?vue&type=template&id=0912b1c0&scoped=true&"
import script from "./Profile2El.vue?vue&type=script&lang=ts&"
export * from "./Profile2El.vue?vue&type=script&lang=ts&"
import style0 from "./Profile2El.vue?vue&type=style&index=0&id=0912b1c0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0912b1c0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VSheet})
